import { trackFormErrorEvent } from '@src/authorisation/helpers'
import Snowplow from '@src/snowplow'

import InputField from '@components/forms/input_field'

import {
  MIN_PASSWORD_LENGTH,
  EMAIL_ERROR,
  SUBMIT_BUTTON_FALLBACK,
  MAX_PASSWORD_LENGTH,
  PASSWORD_TOO_LONG_FALLBACK,
  INVALID_EMAIL_ERROR,
  NOT_VALID_FALLBACK,
  RECAPTCHA_ERROR,
  CREATE_BUTTON_FALLBACK
} from './constants'

export function isFormValid(state, props) {
  if (props.requestEmail) return !state.emailError

  return (
    !state.emailError &&
    !state.passwordError &&
    !!isPasswordValid(state.password) &&
    !!props.email &&
    !!state.recaptchaToken &&
    !state.recaptchaError
  )
}

export function responseHasEmailTakenError(data) {
  return data.errors && EMAIL_ERROR in data.errors
}

export function responseHasInvalidEmailError(data) {
  return data?.errors?.email?.[0] === INVALID_EMAIL_ERROR
}

export function getEmailError(t, email) {
  if (InputField.EmailValidation(email)) {
    return t('e_email_invalid')
  } else if (InputField.EducationalEmailValidation(email)) {
    return t('e_email_use_personal')
  }
  return ''
}

export function getPasswordError(t, password) {
  if (password.length < MIN_PASSWORD_LENGTH) {
    return t('e_password_length')
  }

  if (password.length > MAX_PASSWORD_LENGTH) {
    return PASSWORD_TOO_LONG_FALLBACK
  }

  return ''
}

export function getSubmitButtonText(t, consumerGroup) {
  if (consumerGroup === 'student') {
    return t('a_lets_go') || SUBMIT_BUTTON_FALLBACK
  }

  return t('a_create_account') || CREATE_BUTTON_FALLBACK
}

export function getSignUpRoute(requestEmail) {
  return requestEmail ? 'SIGN_UP_EMAIL' : 'SIGN_UP'
}

export function getPasswordHint(props) {
  const { t, password } = props
  if (password.length < MIN_PASSWORD_LENGTH) return t('e_password_length')

  if (password.length > MAX_PASSWORD_LENGTH) return PASSWORD_TOO_LONG_FALLBACK

  return ''
}

export function trackTextboxFocus(field) {
  Snowplow.trackButtonClickEvent(
    {
      action: 'focusText'
    },
    [
      Snowplow.getButtonContext({
        text: field,
        style: 'textbox',
        location: 'signUpForm'
      }),
      Snowplow.getButtonClickContext({
        action: `Focus ${field} Textbox`
      }),
      Snowplow.getTextBoxContext({
        characterLimit: 0,
        type: 'text',
        name: field
      })
    ]
  )
}

export function getCountry(country) {
  if (!country) return null

  return country.toLowerCase()
}

export function getEmailNotValidError(t) {
  return t('m_use_your_personal_email_student') || NOT_VALID_FALLBACK
}

export const trackEmailExistsEvent = (email, emailError) => {
  return trackFormErrorEvent('email', emailError, email)
}

export const isPasswordValid = (password) => {
  if (password.length < MIN_PASSWORD_LENGTH) return false

  if (password.length > MAX_PASSWORD_LENGTH) return false

  return true
}

export const repsonseHasRecaptchaError = (data) => {
  return data.error && data.error === RECAPTCHA_ERROR
}
